import React, { Component } from "react";

class Buurtgericht extends Component {
  constructor(props) {
    super(props);

    this.state = {
      case: props.case,
      case2: props.case2,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.case !== this.props.case) {
      this.setState({ case: this.props.case });
    }
  }

  render() {
    return (
      <>
        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-1/2 my-3">
          {this.props.SelectField(
            "Hoe oud ben je :",
            "hoeoud",
            [
              {
                value: 46822,
                label: "18 jaar en ouder (tot 23)",
              },
              {
                value: 46821,
                label: "13 - 17 jaar",
              },
              {
                value: 46820,
                label: "10 - 12 jaar",
              },
            ],
            {
              required: true,
            }
          )}
        </form>
        {/* Caso Buurtgericht */}
        {/* <form className="flex justify-between items-start w-1/2  my-3">
          {this.props.handleSelectField(
            "Buurtgericht:",
            "buurtgericht",
            [
              {
                value: 46657,
                label: "Ambulant jongerenwerk",
              },
              {
                value: 46656,
                label: "Youthorganizing",
              },
            ],
            {
              required: true,
            }
          )}
        </form> */}
        {/*Caso 1 Buurtgericht*/}
        {this.state.case === 1 ||
        this.state.case2 === "Ambulant jongerenwerk" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Ontmoet je bij onze activiteiten vrienden?",
              "buurtgericht",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Heb je nieuwe vrienden gemaakt?",
              "buurtgericht_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Doe je nu meer mee aan activiteiten?",
              "buurtgericht_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Kun je goed vertellen wat je denkt en voelt bij de activiteiten?",
              "buurtgericht_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Los je ruzies met anderen goed op?",
              "buurtgericht_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Vind je het makkelijk om samen te werken met anderen?",
              "buurtgericht_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Deel je met de jongerenwerkers wat je bezig houdt?",
              "buurtgericht_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Voel je je door de jongerenwerker gezien en gehoord?",
              "buurtgericht_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Durf je de jongerenwerker om hulp te vragen?",
              "buurtgericht_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Heeft de jongerenwerker je verder geholpen?",
              "buurtgericht_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}
        {/*Caso 2 Youthorganizing*/}
        {this.state.case === 2 || this.state.case2 === "Youthorganizing" ? (
          <form className="grid grid-cols-2 gap-3 mt-3">
            {this.props.SelectFieldStar(
              "Help je anderen bij de activiteiten? ",
              "youthorganizing",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Voel je je gesteund door andere jongeren?  ",
              "youthorganizing_1",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Helpen jullie elkaar in de groep?  ",
              "youthorganizing_2",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
            {this.props.SelectFieldStar(
              "Ik heb door de activiteiten ontdekt waar ik goed in ben (bijv. sport, muziek, leiderschap)?",
              "youthorganizing_3",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Ik heb nieuwe dingen geleerd en gebruik die ook ",
              "youthorganizing_4",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Ik heb succes met waarin ik me ontwikkeld heb",
              "youthorganizing_5",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Ik weet wat gezond en ongezond is ",
              "youthorganizing_6",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Ik voel me fit en gezond  ",
              "youthorganizing_7",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Ik zorg goed voor mezelf",
              "youthorganizing_8",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}

            {this.props.SelectFieldStar(
              "Als het niet goed met me gaat deel ik dat met iemand anders ",
              "youthorganizing_9",
              [
                { value: 46641, stars: 1 },
                { value: 46642, stars: 2 },
                { value: 46643, stars: 3 },
                { value: 46644, stars: 4 },
                { value: 46645, stars: 5 },
              ],
              {
                required: true,
              }
            )}
          </form>
        ) : null}
        {/* pregunta aditional*/}
        <form className="flex justify-between items-start w-11/12 my-4">
          {this.props.TextAreaField(
            "Wat zou je zelf nog kwijt willen aan Dynamo over ons en de jongerenwerkers?",
            "woorden",
            {}
          )}
        </form>
      </>
    );
  }
}

export default Buurtgericht;
